import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  CartQuoteRequestPostData,
  CartQuoteRequestResponse,
} from '~/lib/services/api/cart'

import { TAG_TYPES } from '@lib/config'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { sendCartQuoteRequest } from '~/lib/services/api/cart'

function useSendCartQuoteRequest() {
  const queryClient = useQueryClient()

  const mutationFn = async (data: CartQuoteRequestPostData) => {
    const response = await sendCartQuoteRequest(data)
    if (response.status !== 200) {
      throw new Error('Error sending cart quote request')
    }
    return response.data
  }

  const options: UseMutationOptions<
    CartQuoteRequestResponse,
    DefaultError,
    CartQuoteRequestPostData,
    void
  > = {
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TAG_TYPES.CART] })
    },
  }

  return useMutation(options)
}

export default useSendCartQuoteRequest
